// Safe, non-persistent storage helper for the booking draft.
// Uses sessionStorage (cleared when the tab closes). To limit exposure to XSS,
// we only persist the non-sensitive booking SELECTION and never store personal
// data (name/email/phone/comments). Reads are validated/sanitized before use.

// Only these non-sensitive selection fields are persisted.
const ALLOWED_KEYS = [
  "group",
  "insuranceId",
  "pickup",
  "pickupTime",
  "ret",
  "retTime",
  "outOfHours",
  "promoCode",
];

// Keep only known keys and coerce to safe primitive types.
function sanitizeDraft(raw) {
  if (!raw || typeof raw !== "object") return {};
  const clean = {};
  for (const key of ALLOWED_KEYS) {
    if (!(key in raw)) continue;
    const value = raw[key];
    if (key === "outOfHours") {
      clean[key] = Boolean(value);
    } else if (typeof value === "string") {
      clean[key] = value.slice(0, 2000); // cap length
    }
  }
  return clean;
}

export function loadDraft(key) {
  try {
    const saved = sessionStorage.getItem(key);
    if (!saved) return {};
    return sanitizeDraft(JSON.parse(saved));
  } catch (error) {
    console.error("No se pudo cargar el borrador de reserva:", error);
    return {};
  }
}

export function saveDraft(key, state) {
  try {
    sessionStorage.setItem(key, JSON.stringify(sanitizeDraft(state)));
  } catch (error) {
    console.error("No se pudo guardar el borrador de reserva:", error);
  }
}
